export const REQUEST_OTP_LIMIT_REACHED = `Oops, You've reached your re-send OTP limit, please refresh the page or try SSO login`;
export const VERIFY_OTP_LIMIT_REACHED = `Oops! You’ve run out of attempts, please try re-send otp or SSO login`;
